import React from "react";
import clsx from "clsx";

interface Props {
  className?: string;
  onClick?: any;

  style?: any;
}

const BottomGradient = (props: Props) => {
  const background = {
    background:
      "linear-gradient(180deg, rgba(255, 255, 255, 0) 0%, #FFFFFF 50%",
  };

  return (
    <div
      className={`fixed bottom-0 left-0 right-0 h-[100px] ${
        props.className ?? ""
      }`}
      style={background}
    />
  );
};

export default BottomGradient;
